export default __webpack_public_path__ + "201a1cc.png";